import { useEffect, useState } from 'react';

/** Reactive media query, so layout decisions live in JS where they need to. */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** True when the inspector fits as a third column rather than a drawer. */
export function useWideLayout() {
  return useMediaQuery('(min-width: 1501px)');
}
